import React from 'react';
import FooterNav from './FooterNav/FooterNav';
import './Footer.scss';
const Footer = () => {
    return (
        <div>
            <FooterNav/>
            <div className="footerbody">
                <div className="footerbody-contnet container-sm">
                    <div className="contact">
                        <p><i class="material-icons">location_on</i>Chilonzor, Tashkent, Uzbekistan</p>
                        <p><i className="fa fa-phone"></i>(+1) 254 252 456</p>
                        <p><i className="material-icons">mail</i>sudex@gmail.com</p>
                    </div>
                    <div className="copyright">
                        &copy; 2021 <span className="copybold" id="span">Sudex 2021-2022</span> Все права защищены.
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
